<div class="p-5 redirect-to-ce">
  <div class="card">
    <div class="d-flex justify-content-center flex-column">
      <div class="netcore-logo">
        <img class="logo-img" src="/assets/images/context-charts/netcore-logo.svg" alt="Netcore Logo">
      </div>
      <ng-container *ngIf="shouldShowError">
        <div class="netcore-baloon">
          <div class="lottie-player">
            <lottie-player src="/assets/lottieFiles/404.json" background="transparent" speed="1" loop autoplay>
            </lottie-player>
          </div>
        </div>
        <div class="error-msg">Something went wrong</div>
        <div class="contact-us-text mt-4">
          <div>Uh-oh! There seems to be a problem accessing the link. Please try again.</div>
          <button class="px-primary-btn-xs mt-4" (click)="goBack()">go back</button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
